import { FC } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { AdvisorPage } from 'components/features/coaching/advisorPage/AdvisorPage/AdvisorPage'
import { AdvisorLandingPage } from 'components/features/coaching/advisorLandingPage/AdvisorLandingPage/AdvisorLandingPage'
import { SimpleGuard } from 'interfaces/guards'
import { getMemberAuthStatusActionCreator } from 'actions/memberActions'
import { useSimpleGuard } from 'helpers/loadableHelpers'

const isAuthenticatedGuard: SimpleGuard = {
  name: `isAuthenticated Guard`,
  checker: (state) => {
    const isAuth = isAuthenticatedSelector(state)
    return isAuth !== null
  },
  loader: (dispatch) => {
    dispatch(getMemberAuthStatusActionCreator())
  },
}

export const CoachingPage: FC = () => {
  useSimpleGuard(isAuthenticatedGuard, {}, 'CoachingPage')
  const isAuth = useStoreSelector(isAuthenticatedSelector)
  if (isAuth === null) {
    return (
      <LoadingOverlay />
    )
  }

  if (isAuth) {
    return (
      <AdvisorPage />
    )
  }

  return (
    <AdvisorLandingPage />
  )
}
